export default __webpack_public_path__ + "static/media/sonarqube-tool.d7b8e19a.png";